/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Ln_ScopeInputs */

const es_marketplace_seo_license_row_ln_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Ln_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación diurna hasta 2 millas de costa o puerto.`)
};

const gl_marketplace_seo_license_row_ln_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Ln_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación diurna ata 2 millas de costa ou porto.`)
};

const en_marketplace_seo_license_row_ln_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Ln_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day navigation up to 2 miles from shore or port.`)
};

/**
* | output |
* | --- |
* | "Day navigation up to 2 miles from shore or port." |
*
* @param {Marketplace_Seo_License_Row_Ln_ScopeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_ln_scope = /** @type {((inputs?: Marketplace_Seo_License_Row_Ln_ScopeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Ln_ScopeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_ln_scope(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_ln_scope(inputs)
	return es_marketplace_seo_license_row_ln_scope(inputs)
});